import { useEffect, useState } from 'react'
import { isEqual } from 'lodash'
import usePrevious from './usePrevious'

const useFormHooks = (initialState = {}, callback = () => {}) => {
  const previousInitialState = usePrevious(initialState)
  const [inputs, setInputs] = useState(initialState)
  useEffect(() => {
    if (!isEqual(initialState, previousInitialState)) {
      setInputs(initialState)
    }
  }, [initialState, previousInitialState])

  const handleSubmit = event => {
    if (event) {
      event.preventDefault()
      callback()
    }
  }

  const handleInputChange = event => {
    event.persist()
    setInputs(input => ({ ...input, [event.target.name]: event.target.value }))
  }

  const clearInputs = () => {
    Object.keys(inputs).forEach(field => setInputs(input => ({ ...input, [field]: '' })))
  }

  return {
    handleSubmit,
    handleInputChange,
    inputs,
    clearInputs,
  }
}

export default useFormHooks
